// #region import
import { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import {
  Grid,
  CircularProgress,
  Button
} from '@material-ui/core';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import moment from 'moment';
import Form from '../components/Form';
import { useParams } from "react-router-dom";

// #endregion

// #region style

const useStyles = makeStyles((theme) => ({
  button: {
    width: '48px',
    height: '48px',
    marginTop: '30px',
    color: '#228822',
    '&:hover': {
      backgroundColor: '#ddd'
    }
  },
  fullHeight: {
    height: '100%'
  },
  continueButton: {
    color: '#4d7ac4',
    textTransform: 'none',
    marginBottom: '30px',
    padding: "20px",
    border: "1px solid #4d7ac4",
    '&:hover': {
      backgroundColor: '#eef'
    }
  },
  disconnect: {
    color: 'red',
    border: '1px solid red',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#eef'
    }
  },
  accountIcon: {
    fontSize: '5rem',
    width: '100%',
    color: '#4d7ac4',
    marginBottom: '25px'
  }
}));

// #endregion

const apiUrl = window.apiUrl

function Page({ updateStatus, setApp }) {
  const classes = useStyles()
  var { applicationName } = useParams()

  const [token, setToken, deleteToken] = useCookies(['portaltoken'])
  const [doOnce, setDoOnce] = useState(true)
  const [loading, setLoading] = useState(false)
  const [ssoUser, setssoUser] = useState(null)
  const [application, setApplication] = useState(null)
  const [redirectTrigger, setRedirectTrigger] = useState(null)

  useEffect(() => {
    if (doOnce) {
      setDoOnce(false)
      setLoading(true)
      if (token['portaltoken']) {
        axios.get(apiUrl + "v2/portal/authtoken", { headers: { portalToken: token['portaltoken'] }})
          .then(response => 
            {
              if (response.data.valid) {
                axios.get(apiUrl + "v2/portal/getapplicationsforuser", { headers: { portaltoken: token['portaltoken'] }})
                .then(appsresponse => {
                  let tempApp = appsresponse.data.find(o => o.applicationName === applicationName)
                  if (tempApp != null) {
                    setssoUser(response.data.login)
                    setApplication(tempApp)
                    setApp(tempApp.applicationName)
                    setLoading(false)
                  } else {
                    updateStatus("warning", "User is unauthorized or app doesn't exists")
                    setLoading(false)
                  }
                })
                .catch(appsresponse => {
                  updateStatus("error", "error getting apps for user" + appsresponse.toString())
                  setLoading(false)
                })
              } else {
                updateStatus("warning", "token not valid anymore")
                deleteToken("portaltoken", { path: '/' })
              }
          })
          .catch(response => {
            updateStatus("error", "error authenticating token " + response.ToString())
            deleteToken("portaltoken", { path: '/' })
            setLoading(false)
          })
      } else {
        setLoading(false)
      }
    }
  }, [doOnce])

  function disconnect() {
    deleteToken("portaltoken", { path: '/' })
    updateStatus("info", "Disconnected")
  }

  function updateToken(value) {
    setToken('portaltoken', value, { path: '/', expires: moment(new Date()).add(15, 'days').toDate() });
  }

  function connectAction(data) {
    let tempApp = JSON.parse(data.message).find(o => o.applicationName === applicationName)
    if (tempApp != null) {
      setApplication(tempApp)
      updateStatus("success", "Hello " + data.displayName)
    } else {
      updateStatus("warning", "User is unauthorized or app doesn't exists")
    }

    updateToken(data.token)
    setRedirectTrigger(true)
    setLoading(true)
  }

  useEffect(() => {
    if (redirectTrigger) {
      redirectToApp(token['portaltoken'])
    }
  }, [redirectTrigger])

  function redirectToApp(token) {
    if (application.nGinxAutentication === true) {
      window.location.href = application.url + "sso_validate?token=" + token
    } else {
      axios.get(apiUrl + "v2/ssoapplication/loginwithsso", { headers: { portalToken: token, application: application.applicationName }})
      .then(response => {
        if (response.data.valid) {
          window.location.href = application.url + "Token/" + response.data.token
        } else {
          updateStatus("error", response.data.message)
          setLoading(false)
        }
      })
      .catch(response => {
        updateStatus("error", "error on getting token for app : " + response.toString())
        setLoading(false)
      })
    }
  }

  return (<>
    {loading ?
      <Grid container alignContent="center" justifyContent="center" className={classes.fullHeight}>
        <CircularProgress />
      </Grid>
      :
      <>
        {
          token['portaltoken'] ?
            <Grid container direction="column" alignContent="center" justifyContent="center" className={classes.fullHeight}>
              <AccountBoxIcon className={classes.accountIcon} />
              <Button endIcon={<DoneAllIcon />} className={classes.continueButton} onClick={() => redirectToApp(token['portaltoken'])}>
                Continue As {ssoUser}
              </Button>
              <Button endIcon={<ExitToAppIcon />} className={classes.disconnect} onClick={disconnect}>
                Disconnect
              </Button>
            </Grid>
            :
            <Form connectAction={(data) => connectAction(data)} updateStatus={updateStatus} />
        }
      </>
    }
  </>)
}

export default Page;